(function () {
  'use strict';

  var lastFocused = null;

  /* Move every overlay to <body> so position:fixed escapes any ancestor
     transform/contain/filter that would otherwise clip it (Dawn product-info
     and several other section wrappers create new containing blocks). */
  function portalToBody() {
    var overlays = document.querySelectorAll('.size-guide-v2__overlay');
    overlays.forEach(function (overlay) {
      if (overlay.parentNode !== document.body) {
        document.body.appendChild(overlay);
      }
    });
  }

  function openModal(modal) {
    if (!modal) return;
    lastFocused = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = modal.querySelector('[data-size-guide-close]');
    if (closeBtn) {
      try { closeBtn.focus({ preventScroll: true }); } catch (e) { closeBtn.focus(); }
    }
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') {
      try { lastFocused.focus({ preventScroll: true }); } catch (e) { lastFocused.focus(); }
    }
  }

  function closeAll() {
    document.querySelectorAll('.size-guide-v2__overlay.is-open').forEach(closeModal);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-size-guide-trigger]');
    if (trigger) {
      e.preventDefault();
      var id = trigger.getAttribute('data-size-guide-trigger');
      var modal = document.getElementById(id);
      openModal(modal);
      return;
    }

    var close = e.target.closest && e.target.closest('[data-size-guide-close]');
    if (close) {
      e.preventDefault();
      var overlay = close.closest('.size-guide-v2__overlay');
      closeModal(overlay);
      return;
    }

    if (e.target && e.target.classList && e.target.classList.contains('size-guide-v2__overlay')) {
      closeModal(e.target);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      closeAll();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', portalToBody);
  } else {
    portalToBody();
  }
  /* Re-portal on Shopify section reload (theme editor) */
  document.addEventListener('shopify:section:load', portalToBody);
})();
